import { useState, useEffect } from "react";
import { saveTripDetails } from "../Api/TripDetail";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo"; // Loader
import { getProjectDetails } from "../Api/ProjectMaster";
import { useAuth } from "../Context/AuthContext";

const TripDetail = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const [tripData, setTripData] = useState({
    TripName: "",
    PurposeofTravel: "",
    EmployeeID: "",
    Department: "",
    ManagersName: "",
    TripStartDate: "",
    TripEndDate: "",
    Project: "", // ✅ Added for dropdown selection
  });

  const [projects, setProjects] = useState([]); // ✅ Store project list

  // Fetch projects on component mount
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await getProjectDetails();
        console.log("API Response:", response);

        // If API returns array directly
        if (Array.isArray(response)) {
          setProjects(response);
        }
        // If wrapped in { data: [...] }
        else if (Array.isArray(response?.data)) {
          setProjects(response.data);
        } else {
          setProjects([]);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
        toast.error("Failed to load projects");
      }
    };

    fetchProjects();
  }, []);

  const handleChange = (e) => {
    setTripData({ ...tripData, [e.target.name]: e.target.value });
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   try {
  //     console.log(tripData);
  //     await saveTripDetails(tripData);
  //     toast.success(`🦄 Trip Added Successfully`);
  //     setTripData({
  //       TripName: "",
  //       PurposeofTravel: "",
  //       EmployeeID: "",
  //       Department: "",
  //       ManagersName: "",
  //       TripStartDate: "",
  //       TripEndDate: "",
  //       Project: "",
  //     });
  //     navigate("/viewTrip");
  //   } catch (error) {
  //     toast.error(`🦄 Some Error Happened`);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const tripPayload = {
        ...tripData,
        createdBy: user?.userId.toString() || null, // 👈 attach current login userId
      };
      console.log(tripPayload);
      await saveTripDetails(tripPayload);
      toast.success(`🦄 Trip Added Successfully`);
      setTripData({
        TripName: "",
        PurposeofTravel: "",
        EmployeeID: "",
        Department: "",
        ManagersName: "",
        TripStartDate: "",
        TripEndDate: "",
        Project: "",
      });
      navigate("/viewTrip");
    } catch (error) {
      toast.error(`🦄 Some Error Happened`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Trip Detail</h2>

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Trip Name <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="TripName"
                    value={tripData.TripName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Purpose of Travel <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="PurposeofTravel"
                    value={tripData.PurposeofTravel}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              {/* ✅ Project Dropdown */}
              {/* ✅ Project Dropdown */}
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Project <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Select
                    name="Project"
                    value={tripData.Project}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Select Project --</option>
                    {projects.map((project) => (
                      <option
                        key={project.prozmaPrId}
                        value={project.prozmaPrId}
                      >
                        {project.prTitle}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Department <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="Department"
                    value={tripData.Department}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Manager's Name <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="ManagersName"
                    value={tripData.ManagersName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Trip Start Date <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="TripStartDate"
                    value={tripData.TripStartDate}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Trip End Date <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="TripEndDate"
                    value={tripData.TripEndDate}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button variant="primary" type="submit" className="fields-submit">
                Save Trip
              </Button>
            </div>
          </Form>
        </Container>
      </div>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default TripDetail;

// import { useState } from "react";
// import { saveTripDetails } from "../Api/TripDetail";
// import { Container, Form, Button, Row, Col } from "react-bootstrap";
// //import "../Styling/TripDetail.css";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import Sample14 from "../Components/Logo"; // Import Sample 14 loader
// import { getProjectDetails } from "../Api/ProjectMaster";

// const TripDetail = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false); // Loader State

//   const [tripData, setTripData] = useState({
//     TripName: "",
//     PurposeofTravel: "",
//     EmployeeID: "",
//     Department: "",
//     ManagersName: "",
//     TripStartDate: "",
//     TripEndDate: "",
//   });

//   const handleChange = (e) => {
//     setTripData({ ...tripData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true); // Show Loader
//     try {
//       await saveTripDetails(tripData);
//       toast.success(`🦄 Trip Added Successfully`);
//       setTripData({
//         TripName: "",
//         PurposeofTravel: "",
//         EmployeeID: "",
//         Department: "",
//         ManagersName: "",
//         TripStartDate: "",
//         TripEndDate: "",
//       });
//       console.log(tripData);
//       navigate("/viewTrip");
//     } catch (error) {
//       toast.error(`🦄 Some Error Happened`);
//     } finally {
//       setLoading(false); // Hide Loader
//     }
//   };

//   return (
//     <>
//       <div className="main-content expand">
//         <Container fluid className="fields-container">
//           <h2 className="fields-title">Trip Detail</h2>

//           <Form onSubmit={handleSubmit} className="fields-form">
//             <Row>
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Trip Name <span className="text-red">**</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="TripName"
//                     value={tripData.TripName}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Purpose of Travel <span className="text-red">**</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="PurposeofTravel"
//                     value={tripData.PurposeofTravel}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               {/* <Col md={4}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>Employee ID <span className="text-red">**</span></Form.Label>
//                     <Form.Control type="text" name="EmployeeID" value={tripData.EmployeeID} onChange={handleChange} required />
//                   </Form.Group>
//                 </Col> */}
//             </Row>

//             <Row>
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Department <span className="text-red">**</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="Department"
//                     value={tripData.Department}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Manager's Name <span className="text-red">**</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="ManagersName"
//                     value={tripData.ManagersName}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Trip Start Date <span className="text-red">**</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="date"
//                     name="TripStartDate"
//                     value={tripData.TripStartDate}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row>
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Trip End Date <span className="text-red">**</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="date"
//                     name="TripEndDate"
//                     value={tripData.TripEndDate}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>

//             <div className="fields-btn-container">
//               <Button variant="primary" type="submit" className="fields-submit">
//                 Save Trip
//               </Button>
//             </div>
//           </Form>
//         </Container>
//       </div>

//       {/* Loader Overlay with Sample 14 */}
//       {loading && (
//         <div className="loading-overlay">
//           <Sample14 />
//         </div>
//       )}
//     </>
//   );
// };

// export default TripDetail;
